/**
 * Based off of rules from OWASP password guidelines:
 * https://www.owasp.org/index.php/Authentication_Cheat_Sheet#Implement_Proper_Password_Strength_Controls
 */

import MultiMessageError from '../../../MultiMessageError.js'

export default class PasswordValidator {
  validate (password) {
    let msgs = []
    const add = (msg) => {
      if (msg === null) return
      msg = Array.isArray(msg) ? msg : [msg]
      msgs = msgs.concat(msg)
    }

    if (password.match(/^\s|\s$/)) {
      add('Password may not have leading or trailing whitespace.')
    }

    if (password.length < 10) {
      add('Password must be at least 10 characters long.')
    }

    if (password.length >= 128) {
      add('Password may be no longer than 128 characters long.')
    }

    if (password.match(/[\r\n]/)) {
      add('Password may not contain newline characters.')
    }

    add(messagesFromComplexityTests(password))
    add(messageFromRepeatingCharacterTest(password))

    return msgs.length ? new MultiMessageError(msgs) : null
  }
}

function messagesFromComplexityTests (password) {
  const numberOfAllowedFailures = 1
  const lengthPasswordsBecomePassphrases = 20

  let msgs = []
  const add = (msg) => { msgs = msgs.concat(msg) }

  if (password.length >= lengthPasswordsBecomePassphrases) {
    return null  // Allow passphrases to skip complexity rules
  }

  if (!password.match(/[A-Z]/)) {
    add('Password should contain an uppercase letter.')
  }

  if (!password.match(/[a-z]/)) {
    add('Password should contain a lowercase letter.')
  }

  if (!password.match(/\d/)) {
    add('Password should contain a number.')
  }

  if (!password.match(/[^a-z0-9]/i)) {
    add('Password should contain a punctuation or special character.')
  }

  if (msgs.length > numberOfAllowedFailures) {
    return msgs
  }
  else {
    return null
  }
}

function messageFromRepeatingCharacterTest (password) {
  if (password.length < 3) return null

  let matchCount = 0
  let prevChar = password.charAt(0)

  for (let i = 1; i < password.length; i++) {
    const curChar = password.charAt(i)

    if (prevChar === curChar) {
      if (matchCount === 0) {
        matchCount = 2
      }
      else {
        matchCount += 1
      }
    }
    else {
      matchCount = 0
    }

    if (matchCount === 3) {
      return 'Password must not contain three or more consecutively repeating characters.'
    }

    prevChar = curChar
  }

  return null
}
